module.exports = __webpack_public_path__ + "img/features-bg_16.c6e4d1eb.png";